import React, { useState, useEffect } from "react";
import classNames from "classnames";

import { ANSWERMODE_SUBMIT } from '../util/constants';

import { getAnswerMode } from '../util/settings';

import QuizLayout, { QuizMain, QuizInput } from "./QuizLayout";
import AnswerOutput from './AnswerOutput';
import Numpad from './Numpad';

import "./QuizUi.css";

const QuizUi = ({ children, className, hide789, twoDigits, answer, disabled, isCorrect, isWrong, onAnswer, labels }) => {
    
  const [input, setInput] = useState('');
  const answerMode = getAnswerMode();
  const isSubmitMode = (answerMode === ANSWERMODE_SUBMIT);

  const onButtonPress = (num) => {

    if (isSubmitMode) {
      if (twoDigits && input) {
        const firstDigit = parseInt((input+'')[0], 10)*10;
        setInput(firstDigit + num);
      }
      else {
        setInput(num);
      }
    }
    else { // isSubmitMode === true
      if (twoDigits) {
        if (input) {
          // 2nd digit is final answer
          onAnswer(input*10 + num, isSubmitMode);
        }
        else {
          // stage digit only if return value provided
          if (onAnswer(num, isSubmitMode) === true) {
            setInput(num);
          }
        }
      }
      else {
        onAnswer(num, isSubmitMode);
      }
    }
  }

  useEffect(() => {
    if (answer && input) {
      setInput('');
    }
  }, [answer, input])

  const onDeletePress = () => {
    if (!disabled) {
      if (twoDigits && input >= 10) {
        setInput(Math.floor(input/10));
      }
      else {
        setInput('');
      }
    }
  }
  const onSubmitPress = () => {
    if (!disabled) {
      onAnswer(input, isSubmitMode);
      setInput('');
    }
  }

  const hasInput = input !== '';
  const hasAnswer = typeof answer === 'number';
  const displayValue = hasAnswer ? (labels ? labels[answer] : answer) : (
    (isSubmitMode || input) ? 
    (labels ? labels[input] : input) : '');

  return <QuizLayout
        className={classNames(className, {
          "--disabled": disabled,
          "--correct": isCorrect,
          "--wrong": isWrong,
        })}
      >
      <QuizMain>
      {children}
      <AnswerOutput
        value={displayValue}
        disabled={disabled}
        isCorrect={isCorrect}
        isWrong={isWrong}
        higlighted={hasInput && !hasAnswer}
      />
    </QuizMain>
    <QuizInput>
      <Numpad
        labels={labels}
        isSubmitMode={isSubmitMode}
        canSubmit={isSubmitMode && (hasInput || hasAnswer)}
        onButtonPress={onButtonPress}
        onDeletePress={onDeletePress}
        onSubmitPress={onSubmitPress}
        disabled={disabled}
        hide789={hide789}
        highlightWrongIndex={isWrong ? answer : null}
        highlightCorrectIndex={isCorrect ? answer : null}
        highlightStagedIndex={!hasAnswer && hasInput && !twoDigits ? input : null}
      />
    </QuizInput>
  </QuizLayout>
};

export default QuizUi;